export const FETCH_START = 'FETCH_START';
export const FETCH_END = 'FETCH_END';
export const FORECAST_LEVEL_DATA_SUCCESS = 'FORECAST_LEVEL_DATA_SUCCESS';
export const FORECAST_LEVEL_BY_ID = 'FORECAST_LEVEL_BY_ID';
export const FORECAST_LEVEL_DROPDWON_SUCCESS =
  'FORECAST_LEVEL_DROPDWON_SUCCESS';
export const SALES_FORECAST_FORMAT_LIST_SUCCESS =
  'SALES_FORECAST_FORMAT_LIST_SUCCESS';
export const DYNAMIC_QUERY_SALES_FORECAST_DETAILS_SUCCESS =
  'DYNAMIC_QUERY_SALES_FORECAST_DETAILS_SUCCESS';
export const SALES_FORECAST_QUERY_SINGLE_SUCCESS =
  'SALES_FORECAST_QUERY_SINGLE_SUCCESS';
export const SALES_FORECAST_QUERY_FIELDS_SUCCESS =
  'SALES_FORECAST_QUERY_FIELDS_SUCCESS';
export const DYNAMIC_QUERY_FORECAST_FIELDS_SUCCESS =
  'DYNAMIC_QUERY_FORECAST_FIELDS_SUCCESS';
export const SALES_FORECAST_UPLOAD_SUCCESS = 'SALES_FORECAST_UPLOAD_SUCCESS';
export const SALES_FORECAST_DATA_SUCCESS = 'SALES_FORECAST_DATA_SUCCESS';

// New Forecast API Action Types
export const GET_FORECASTS_START = 'GET_FORECASTS_START';
export const GET_FORECASTS_SUCCESS = 'GET_FORECASTS_SUCCESS';
export const GET_FORECASTS_FAIL = 'GET_FORECASTS_FAIL';

export const GET_FORECAST_BY_ID_START = 'GET_FORECAST_BY_ID_START';
export const GET_FORECAST_BY_ID_SUCCESS = 'GET_FORECAST_BY_ID_SUCCESS';
export const GET_FORECAST_BY_ID_FAIL = 'GET_FORECAST_BY_ID_FAIL';

export const CREATE_FORECAST_START = 'CREATE_FORECAST_START';
export const CREATE_FORECAST_SUCCESS = 'CREATE_FORECAST_SUCCESS';
export const CREATE_FORECAST_FAIL = 'CREATE_FORECAST_FAIL';

export const UPDATE_FORECAST_START = 'UPDATE_FORECAST_START';
export const UPDATE_FORECAST_SUCCESS = 'UPDATE_FORECAST_SUCCESS';
export const UPDATE_FORECAST_FAIL = 'UPDATE_FORECAST_FAIL';

export const DELETE_FORECAST_START = 'DELETE_FORECAST_START';
export const DELETE_FORECAST_SUCCESS = 'DELETE_FORECAST_SUCCESS';
export const DELETE_FORECAST_FAIL = 'DELETE_FORECAST_FAIL';

export const GET_FORECAST_DATA_START = 'GET_FORECAST_DATA_START';
export const GET_FORECAST_DATA_SUCCESS = 'GET_FORECAST_DATA_SUCCESS';
export const GET_FORECAST_DATA_FAIL = 'GET_FORECAST_DATA_FAIL';

export const SAVE_FORECAST_DATA_START = 'SAVE_FORECAST_DATA_START';
export const SAVE_FORECAST_DATA_SUCCESS = 'SAVE_FORECAST_DATA_SUCCESS';
export const SAVE_FORECAST_DATA_FAIL = 'SAVE_FORECAST_DATA_FAIL';

export const EXECUTE_QUERY_START = 'EXECUTE_QUERY_START';
export const EXECUTE_QUERY_SUCCESS = 'EXECUTE_QUERY_SUCCESS';
export const EXECUTE_QUERY_FAIL = 'EXECUTE_QUERY_FAIL';

export const UPLOAD_FORECAST_DATA_START = 'UPLOAD_FORECAST_DATA_START';
export const UPLOAD_FORECAST_DATA_SUCCESS = 'UPLOAD_FORECAST_DATA_SUCCESS';
export const UPLOAD_FORECAST_DATA_FAIL = 'UPLOAD_FORECAST_DATA_FAIL';

export const COPY_FORECAST_DATA_START = 'COPY_FORECAST_DATA_START';
export const COPY_FORECAST_DATA_SUCCESS = 'COPY_FORECAST_DATA_SUCCESS';
export const COPY_FORECAST_DATA_FAIL = 'COPY_FORECAST_DATA_FAIL';

// External API Action Types
export const EXTERNAL_LOGIN_START = 'EXTERNAL_LOGIN_START';
export const EXTERNAL_LOGIN_SUCCESS = 'EXTERNAL_LOGIN_SUCCESS';
export const EXTERNAL_LOGIN_FAIL = 'EXTERNAL_LOGIN_FAIL';

export const GET_EXTERNAL_ATTRIBUTES_START = 'GET_EXTERNAL_ATTRIBUTES_START';
export const GET_EXTERNAL_ATTRIBUTES_SUCCESS = 'GET_EXTERNAL_ATTRIBUTES_SUCCESS';
export const GET_EXTERNAL_ATTRIBUTES_FAIL = 'GET_EXTERNAL_ATTRIBUTES_FAIL';

export const GET_EXTERNAL_QUERIES_START = 'GET_EXTERNAL_QUERIES_START';
export const GET_EXTERNAL_QUERIES_SUCCESS = 'GET_EXTERNAL_QUERIES_SUCCESS';
export const GET_EXTERNAL_QUERIES_FAIL = 'GET_EXTERNAL_QUERIES_FAIL';

export const GET_FORECAST_ATTRIBUTE_LABELS_START = 'GET_FORECAST_ATTRIBUTE_LABELS_START';
export const GET_FORECAST_ATTRIBUTE_LABELS_SUCCESS = 'GET_FORECAST_ATTRIBUTE_LABELS_SUCCESS';
export const GET_FORECAST_ATTRIBUTE_LABELS_FAIL = 'GET_FORECAST_ATTRIBUTE_LABELS_FAIL';

export const RUN_SQL_WORKBENCH_START = 'RUN_SQL_WORKBENCH_START';
export const RUN_SQL_WORKBENCH_SUCCESS = 'RUN_SQL_WORKBENCH_SUCCESS';
export const RUN_SQL_WORKBENCH_FAIL = 'RUN_SQL_WORKBENCH_FAIL';

// Budget Forecast Action Types
export const BUDGET_FORECAST_FORMAT_LIST_SUCCESS = 'BUDGET_FORECAST_FORMAT_LIST_SUCCESS';